export enum EnsurePromiseAction {
  ADD = "add",
  REMOVE = "remove",
  IGNORE = "ignore",
}
